// extracted by mini-css-extract-plugin
export var divider = "_ou-0";
export var systemMessage = "_ou-1";